import { Injectable } from '@angular/core'
import {GuardResult} from '@angular/router'
import { CheckoutB2BStepsSetGuard } from '@spartacus/checkout/b2b/components'
import { CheckoutStep, CheckoutStepType} from '@spartacus/checkout/base/root'
import { Observable, of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EbCheckoutStepsSetGuard extends CheckoutB2BStepsSetGuard {
  protected override isB2BStepSet(
    step: CheckoutStep,
    isAccountPayment: boolean
  ): Observable<GuardResult> {
    super.isPaymentTypeSet(step).subscribe()
    if (step && !step.disabled) {
      switch (step.type[0]) {
        case CheckoutStepType.PAYMENT_TYPE: {
          return super.isPaymentTypeSet(step)
        }
        case CheckoutStepType.DELIVERY_ADDRESS: {
          return super.isDeliveryAddressAndCostCenterSet(step, isAccountPayment)
        }
        case CheckoutStepType.DELIVERY_MODE: {
          return super.isDeliveryModeSet(step)
        }
        case CheckoutStepType.PAYMENT_DETAILS: {
          return super.isPaymentTypeSet(step)
        }
        case CheckoutStepType.REVIEW_ORDER: {
          break
        }
      }
    }
    return of(true)
  }
}
